<template>
  <div class="task-table table-responsive-sm mt-md-3 px-md-3">
    <table
      class="table task-tabel-main table-borderless pl-md-5"
      v-if="tasks.length"
    >
      <thead class="task-tabel-head">
        <tr>
          <th
            scope="col"
            v-for="(col, index) in fields"
            :key="index"
            :class="col == 'Status' ? 'text-center' : ''"
          >
            {{ $t(`task.table.${col}`) }}
          </th>
        </tr>
      </thead>
      <tbody class="task-tabel-body">
        <tr v-for="(task, index) in tasks" :key="index">
          <td
            class="text-left"
            @click="showTask(task)"
            :style="{ width: !overviewFields ? `${250}px` : `${150}px` }"
          >
            {{ task.task.title }}
          </td>
          <td
            v-if="overviewFields"
            class="text-left"
            @click="showTask(task)"
            :style="{ width: !overviewFields ? `${250}px` : `${150}px` }"
          >
            {{ assignedByOrAssignies(task.task) }}
          </td>
          <td v-if="overviewFields" class="text-left" @click="showTask(task)">
            {{ formatDate(task.task.createdBy.creationDate) }}
          </td>
          <td class="text-left" @click="showTask(task)">
            {{ formatDate(task.task.dueDate) }}
          </td>
          <td v-if="notificationField">
            <a
              href="#!"
              @click.prevent.stop="
                sendNotification(task.task, $t('task.notificationSentence'))
              "
            >
              {{ $t("global.notification") }}
            </a>
          </td>
          <td v-if="!($route.path == '/personalTasks' && task.task.bulk)">
            <div :class="task.task.status">
              <select
                v-model="task.task.status"
                @change="updateStatus(task.task, task.task.status)"
              >
                <option value="pending">{{ $t("global.pending") }}</option>
                <option value="Done">{{ $t("global.done") }}</option>
              </select>
            </div>
          </td>
          <td v-else>
            <div :class="task.task.users[index(task.task)].status">
              <select
                v-model="task.task.users[index(task.task)].status"
                @change="
                  updateStatus(
                    task.task,
                    task.task.users[index(task.task)].status,
                    task.users
                  )
                "
              >
                <option value="pending">{{ $t("global.pending") }}</option>
                <option value="Done">{{ $t("global.done") }}</option>
              </select>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    <div class="no-task" v-if="!tasks.length">
      <h3>{{ $t("task.noData") }}</h3>
    </div>
  </div>
</template>
<script>
import TimeUtils from '../../utils/TimeUtils';
import TaskHelper from '../../helper/TaskHelper';

export default {
  props: ['fields', 'tasks', 'notificationField', 'overviewFields'],

  mounted() {
    this.user = this.$store.state.user.informations;
  },

  data() {
    return {
      user: {},
    };
  },

  methods: {
    index(task) {
      return task.users.findIndex(u => u.reference == this.user.reference);
    },

    showTask(task) {
      let modal = 'simple-task';
      if (this.$route.path != '/personalTasks') {
        this.$emit('showTask', task);
        modal = task.task.bulk ? 'bulk-task-view' : 'simple-task';
      } else {
        let users = [];
        if (task.task.bulk) {
          task.task.users.forEach((u) => {
            if (u.reference == this.user.reference) {
              users.push(u);
            }
          });
        } else {
          users = task.task.users;
        }
        this.$emit('showTask', task, users);
      }
      this.$root.$emit('simpleTaskView', task.task.reference); // to fetch lastest comments
      this.$modal.show(modal);
    },

    assignedByOrAssignies(task) {
      let users = '';
      if (this.$route.path == '/personalTasks') {
        users = `${task.createdBy.firstName} ${task.createdBy.lastName}`;
      } else {
        task.users.forEach((user, index) => {
          if (index == task.users.length - 1) {
            users = users.concat(`${user.firstName} ${user.lastName}`);
          } else {
            users = users.concat(`${user.firstName} ${user.lastName}, `);
          }
        });
      }
      return users.length > 60
        ? `${users.slice(0, 60)} ...`
        : users.slice(0, 60);
    },

    formatDate(date) {
      return date && TimeUtils.dayMonYear(date);
    },

    updateStatus(task, status, emps) {
      const st = TaskHelper.updateStatus(task, status, this.user, emps);
      if (st) {
        this.$miniToastr.success(this.$t('global.updateToaster'));
        const desc = `changé le statut en ${
          status == 'pending' ? 'À faire' : 'Terminé'
        }`;
        this.sendNotification(task, desc);
      } else {
        this.$miniToastr.error(this.$t('global.noUpdateToaster'));
      }
    },

    notificationDescription(task, desc) {
      return `${task.createdBy.firstName} ${task.createdBy.lastName} ${desc} : ${task.title}`;
    },

    async sendNotification(task, desc) {
      const description = this.notificationDescription(task, desc);
      const users = task.users;
      const status = TaskHelper.sendNotification(task, users, description);
      status
        ? this.$miniToastr.success(this.$t('global.notificationToaster'))
        : this.$miniToastr.error('global.noNotificationToaster');
    },
  },
};
</script>
<style lang="scss" scoped>
.mc {
  background-color: black;
}
.btn.btn-primary.dropdown-toggle {
  background-color: transparent !important;
  border: none;
  box-shadow: none !important;
  color: #000;
  text-transform: capitalize;
}
.task-table {
  height: auto;
  @media (min-width: 320px) and (max-width: 767px) {
    padding: 0 10px;
  }
  .task-tabel-main {
    .task-tabel-head {
      tr {
        border-bottom: 1px solid #ddd;
        th {
          color: #303778;
          font-family: "SF-Pro-Text";
          font-size: 12px;
          text-align: left;
        }
      }
    }
    .task-tabel-body {
      tr {
        cursor: pointer;
        border-bottom: 1px solid #ddd;
        td {
          color: #212529;
          font-family: "SF-Pro-Text";
          padding-top: 7px;
          padding-bottom: 7px;
          a {
            border: 1px solid #4f78e2;
            color: #4f78e2;
            padding: 6px 10px;
            border-radius: 4px;
            display: inline-block;
            width: 100%;
            margin: 0 auto;
            text-align: center;
            font-family: "SF-Pro-Text";
          }
        }
      }
    }
  }
}
.no-task {
  padding-top: 20px;
  padding-left: 15px;
}
.Done {
  position: relative;
  select {
    -moz-appearance: none;
    appearance: none;
    height: 30px;
    width: 120px;
    object-fit: contain;
    border-radius: 3px;
    border: none;
    background-color: transparent !important;
    color: #17c671 !important;
    font-family: "SF-Pro-Text";
    font-size: 11px;
    box-shadow: none !important;
    text-shadow: none;
    outline: none !important;
    padding: 0 14px;
    margin: 0 auto !important;
  }
  &:after {
    background-image: url("~@/assets/images/drop-arrow-done.svg");
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    left: 80%;
    top: 4px;
  }
  width: 120px;
  height: 30px;
  object-fit: contain;
  border-radius: 3px;
  border: solid 1px #17c671;
  background-color: rgba(23, 198, 113, 0.24) !important;
  color: #17c671 !important;
  font-family: "SF-Pro-Text";
  box-shadow: none !important;
  font-size: 11px;
}
.pending {
  position: relative;
  width: 120px;
  height: 30px;
  select {
    -moz-appearance: none;
    appearance: none;
    height: 30px;
    object-fit: contain;
    border-radius: 3px;
    border: solid 1px #ffb400;
    background-color: rgba(255, 180, 0, 0.24) !important;
    color: #ffb400 !important;
    font-family: "SF-Pro-Text";
    margin: 0 auto;
    font-size: 11px;
    box-shadow: none !important;
    text-shadow: none;
    outline: none !important;
    padding: 0 20px;
    width: 120px;
  }
  &:before {
    display: none;
  }
  &:after {
    background-image: url("~@/assets/images/drop-arrow-pending.svg");
    position: absolute;
    content: "";
    width: 30px;
    height: 30px;
    left: 80%;
    top: 4px;
  }
}
</style>
